(function() { module.exports = window["wp"]["coreData"]; }());